<tt-page *ngIf="!!setting">
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card>
            <tt-tabs ttRememberId="gb_consignmentsplitedit" [(ttSelectedId)]="setting.gb_consignmentsplitedit">
                <tt-tab ttId="LINE" ttLabel="gb_consignmentsplitedit_line"></tt-tab>
                <tt-tab ttId="MANUAL" ttLabel="gb_consignmentsplitedit_manual"></tt-tab>
            </tt-tabs>

            <div [hidden]="setting.gb_consignmentsplitedit !== 'LINE'">
                <ng-container *ngTemplateOutlet="selectionCriteria"></ng-container>
            </div>
        </tt-card>

        <tt-list-legacy [hidden]="setting.gb_consignmentsplitedit !== 'LINE'" [listItems]="itemsListSplitEdits" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>
        <tt-list-legacy [hidden]="setting.gb_consignmentsplitedit !== 'MANUAL'" [listItems]="itemsListSplitEdits" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="consignmentsplitedit_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_consignmentsplitedit_line" ttTranslate>
                        <ng-container *ngTemplateOutlet="selectionCriteria"></ng-container>
                    </tt-card>

                    <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListSplitEdits" ltype="multi" [optionfunc]="toggleChosen.bind(this)"></tt-list-legacy>
                </tt-divider-pane>

                <tt-divider-pane ttSize="50">
                    <tt-card class="col-xs-12 p-5" ttHeading="gb_consignmentsplitedit_manual" ttTranslate></tt-card>
                    <tt-list-legacy class="col-xs-12 p-5" [listItems]="itemsListSplitEdits" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>

<ng-template #selectionCriteria>
    <ng-container *ngIf="!!setting">
        <tt-select ttLabel="custact_no_consignmentplan_moveto" [(ttModel)]="setting.custact_no_consignmentplan" [ttData]="selectListPlans" ttDataId="custact_no_consignmentplan" ttDataName="consignmentplan_name"></tt-select>
        <tt-button ttText="consignmentsplitedit_move_line" (ttClick)="moveChanges()" [ttSpin]="movingLines" ttIcon="fas fa-sync"></tt-button>
    </ng-container>
</ng-template>
